import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api_urls } from "../../utils/api-urls";
import { project_name } from "../../utils/constant";
import Logo from '../../assets/images/logo-small.png';
import * as AuthActions from '../../redux/actions/authAction';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { superadminAdminPartnerDetails } = useSelector((state) => state.authReducer);

  return (
    <>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 20px', position: 'fixed', width: '100vw', backgroundColor: '#FFF', zIndex: 800 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', }}>
          <span style={{ color: "#6D54CF", fontSize: '22px', fontWeight: 'bold' }}>{project_name}</span>
          <span style={{ fontSize: '12px', fontWeight: '500', padding: '5px 15px 4px 15px', borderRadius: '20px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: '#FFF' }}>{superadminAdminPartnerDetails?.role === 'Partner' ? (superadminAdminPartnerDetails?.label || 'Partner') : superadminAdminPartnerDetails?.role}</span>
        </div>

        <main onClick={() => dispatch(AuthActions.logout({ onComplete: (route) => navigate(route) }))} style={{ display: "flex", alignItems: "center", cursor: 'pointer' }}>
          <img src={superadminAdminPartnerDetails?.profile_picture ? api_urls + superadminAdminPartnerDetails?.profile_picture : Logo} style={{ width: 40, height: 40, marginLeft: "5px", marginRight: "5px", borderRadius: '100px' }} />
          <p>{superadminAdminPartnerDetails?.role === 'Superadmin' ? superadminAdminPartnerDetails?.name : superadminAdminPartnerDetails?.role == 'Admin' ? superadminAdminPartnerDetails?.admin_name : superadminAdminPartnerDetails?.partner_name}</p>
        </main>
      </header>
    </>
  );
};

export default Header;